export default () => ({
  cover_art: {
    type: 'Upload',
    permittedFormats: 'image/*',
    label: 'Cover Art',
    help: 'Recommended dimensions: 1100x620. Your image will be cropped to a 16x9 ratio if your original image is a different ratio. Supported image format: JPG, PNG, GIF. Size limit 10MB.',
    hasRemoveUploadButton: true,
    hasReplaceUploadButton: true,
    maxUploadSize: 10,
    removeUploadButtonText: 'Remove File',
    replaceUploadButtonText: 'Upload new File',
    uploadButtonText: 'Choose File',
    uploadType: 'image',
  },
});
